import React from 'react';
import { Chip } from '@mui/material';
import {
  CollectionEmailSendListItem,
  CollectionEmailSendStatus,
  CollectionEmailType,
  STATUS_LABELS,
  getModuleLabel,
  getSourceLabel,
  getToneLabel,
} from '../model';
import { STATUS_CHIP_COLOR, getModuleChipStyle, getSourceChipStyle, getToneChipStyle } from '../chipStyles';

// One rendering of each email-send attribute, so the Email History page, the per-client table and
// the detail modal cannot drift apart on how the same row reads. The style getters return Chip
// props (variant/sx) and are spread directly.

export const ModuleChip: React.FC<{ emailType: CollectionEmailType }> = ({ emailType }) => (
  <Chip label={getModuleLabel(emailType)} size="small" {...getModuleChipStyle(emailType)} />
);

export const ToneChip: React.FC<{ row: Pick<CollectionEmailSendListItem, 'tone'> }> = ({ row }) => (
  <Chip label={getToneLabel(row)} size="small" {...getToneChipStyle(row)} />
);

export const SourceChip: React.FC<{ row: Pick<CollectionEmailSendListItem, 'one_off' | 'send_source'> }> = ({
  row,
}) => <Chip label={getSourceLabel(row)} size="small" {...getSourceChipStyle(row)} />;

export const StatusChip: React.FC<{ status: CollectionEmailSendStatus }> = ({ status }) => (
  <Chip label={STATUS_LABELS[status]} color={STATUS_CHIP_COLOR[status]} size="small" />
);
